import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateDefaultTrackingPageUrl = {
  name: "updateDefaultTrackingPageUrl" as const,
  input: z.object({
    teamId: zExt.objectId(),
    url: z.string().url().nullable(),
  }),
  output: z.null(),
};
